import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Nav from 'react-bootstrap/Nav'

type Props = {
  items: Array<{
    name: string
    url: string
  }>
}

const SubMenu = ({ items }: Props) => {
  const [isClient, setIsClient] = useState(false)
  const router = useRouter()

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) return ''

  return (
    <Nav variant='tabs' activeKey={router.asPath}>
      {items.map((item, index) => (
        <Nav.Item key={index}>
          <Link scroll={false} href={item.url}>
            <Nav.Link href={item.url}>{item.name}</Nav.Link>
          </Link>
        </Nav.Item>
      ))}
    </Nav>
  )
}

export default SubMenu
